import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBold = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6.03516 4.375H13.0433C15.2985 4.375 17.1267 6.20316 17.1267 8.45833V8.66667C17.1267 9.87664 16.6004 10.9637 15.7642 11.7114C17.0693 12.3929 17.9602 13.7591 17.9602 15.3333V15.5417C17.9602 17.7968 16.132 19.625 13.8768 19.625H6.03516V4.375ZM13.8768 18.125C15.3035 18.125 16.4602 16.9684 16.4602 15.5417V15.3333C16.4602 13.9066 15.3035 12.75 13.8768 12.75H7.53516V18.125H13.8768ZM7.53516 11.25H13.0433C14.47 11.25 15.6267 10.0934 15.6267 8.66667V8.45833C15.6267 7.0316 14.47 5.875 13.0433 5.875H7.53516V11.25Z",
		fill: "currentColor"
	})]
});
export default SvgBold;
